module.exports = __webpack_public_path__ + "img/error.e6081f5c.svg";